export class Mg2Action {
    register() {
        document.addEventListener("click", (e) => {
            var _a;
            const el = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest("[data-mg2-action]");
            if ((el === null || el === void 0 ? void 0 : el.getAttribute("data-mg2-action")) === this.actionName) {
                e.preventDefault();
                this.run(e);
            }
        });
    }
}
